import { graphql } from "@/graphql/codegen/gql"

graphql(`
  mutation SubmitPriceChanges($input: SubmitPriceChangesInput!) {
    priceChange {
      submitPriceChanges(input: $input) {
        id
        changeId
        status
      }
    }
  }
`)
